import { ChatStatusType } from 'utils';
export class ChatViewProps {
    SessionRef!: string;
    ChatStatusType!: ChatStatusType;
    ClientUniqueId!: string;
    WebChatName!: string;
    CustomerName!: string;
}